import { render } from "./pageGG.vue?vue&type=template&id=4b355ec8&scoped=true"
import script from "./pageGG.vue?vue&type=script&lang=js"
export * from "./pageGG.vue?vue&type=script&lang=js"

import "./pageGG.vue?vue&type=style&index=0&id=4b355ec8&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b355ec8"]])

export default __exports__